import * as React from "react";
import { GlobalConnectedProps, withVariableLookup } from "components/form/VariableLookup/VariableLookup";
import { default as Text, TextProps, DebounceText } from "components/form/Text/Text";

const TextWithInputRef = (props: TextProps & GlobalConnectedProps) => <DebounceText textInputRef={props.textInputRef} {...props} />;
export const VariableLookupText = withVariableLookup()(TextWithInputRef);
